export default __webpack_public_path__ + "static/media/Documentation of stones Malachite.0181e628.jpg";